import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import Image from 'components/Image';
import H2 from 'components/H2';
import Video from 'components/Video';
import { Box } from 'components/Grid';
import { height } from 'styled-system';
import { cursor } from 'utils/styles/customStyledSystemProps';
import playIcon from './../../images/Play-overlay.svg';

const MediaGridItemStyled = styled.div`
	${cursor};
	${height}
	width: 100%;
	position: relative;

	img {
		display: block;
	}

	.MediaGridItem-TextWrapper {
		display: flex;
		text-align: center;
		justify-content: center;
		align-items: center;

		@media screen and (min-width: 500px) {
			min-height: 400px;
		}
	}

	.MediaGridItem-ImageWrapper {
		height: auto;
		height: 100%;
		object-fit: cover;
	}

	.MediaGridItem-Iframe {
		width: 100%;
		position: relative;

		iframe {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}

	.MediaGridItem-VideoWrapper + .MediaGridItem-TextWrapper,
	.MediaGridItem-ImageWrapper + .MediaGridItem-TextWrapper {
		position: absolute;
		z-index: 1;
		top: 50%;
		left: 50%;
		width: 100%;
		transform: translateY(-50%) translateX(-50%);
		padding: 20px;

		h2 {
			text-align: center;
		}
	}

	.MediaGridItem-VideoWrapper {
		height: 100%;
		position: relative;

		.poster-image {
			position: absolute;
			height: 100%;
			left: 0;
			top: 0;
			width: 100%;

			transition: opacity 0.3s ease;
		}

		.play-icon {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translateY(-50%) translateX(-50%);
			z-index: 1;
			opacity: ${props => (props.playing ? 0 : 1)};
		}
	}

	.MediaGridItem-TextWrapper,
	video,
	h2,
	.gatsby-image-wrapper {
		transition: opacity 0.4s ease;
	}

	video {
		opacity: ${props => (props.playing ? 1 : 0)} !important;
	}

	.gatsby-image-wrapper,
	h2 {
		opacity: ${props => (!props.playing ? 1 : 0)} !important;
	}
`;

const MediaGridItem = ({ image, text, autoplayVideo, video, iframe, ...props }) => {
	const [playing, setPlaying] = useState(autoplayVideo || false);
	const videoEl = useRef(null);

	const togglePlaying = () => {
		if (!autoplayVideo) {
			playing ? videoEl.current.pause() : videoEl.current.play();
			setPlaying(!playing);
		}
	};

	if (!text && !image && !video && !iframe) {
		return false;
	}

	const cursor = () => {
		if (video && !autoplayVideo) {
			if (video && playing) {
				return 'pause';
			}
			return 'play';
		}

		return '';
	};

	return (
		<MediaGridItemStyled
			className="MediaGridItem"
			p={[2, 4]}
			{...props}
			cursor={cursor()}
			playing={playing}
		>
			{/* Only image */}

			{image && !video && !autoplayVideo ? (
				<Image
					className="MediaGridItem-ImageWrapper"
					height={props.height}
					fluid={image && image?.fluid}
				/>
			) : (
				false
			)}
			{/* Video */}
			{video && (
				<div onClick={togglePlaying} className="MediaGridItem-VideoWrapper">
					<Video>
						<video
							muted={autoplayVideo}
							playsInline
							autoPlay={autoplayVideo}
							loop
							ref={videoEl}
							src={video.file.url}
							poster={image && image?.fluid.src}
						/>
					</Video>
					<img className="play-icon" src={playIcon} />
					<div className="poster-image">{image && <Image height="100%" fluid={image.fluid} />}</div>
				</div>
			)}
			{/* Text */}
			{text && (
				<div className="MediaGridItem-TextWrapper">
					<H2 textAlign={props.fullWidth ? 'center' : 'left'} color={image || video ? 'white' : ''}>
						{text}
					</H2>
				</div>
			)}

			{iframe?.iFrame && (
				<Box
					height={['300px', '600px']}
					width="100%"
					className="MediaGridItem-Iframe"
					dangerouslySetInnerHTML={{ __html: iframe.iFrame }}
				></Box>
			)}
		</MediaGridItemStyled>
	);
};

MediaGridItem.propTypes = {
	image: PropTypes.object,
	text: PropTypes.string,
	autoplayVideo: PropTypes.bool,
	video: PropTypes.oneOfType([PropTypes.object]),
	fullWidth: PropTypes.bool
};

export default MediaGridItem;
